import Layout from '@/layout/base/layoutSegfy'

export default [{
    path: '/home',
    component: Layout,
    children: [
        {
            path: '',
            component: () => import('@/components/dashboard/home'),
            meta: {
                auth: true
            } 
        }
    ]
}]
